import { render, staticRenderFns } from "./family.vue?vue&type=template&id=45466879&scoped=true"
import script from "./family.vue?vue&type=script&lang=js"
export * from "./family.vue?vue&type=script&lang=js"
import style0 from "./family.vue?vue&type=style&index=0&id=45466879&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45466879",
  null
  
)

export default component.exports